import { FC } from 'react';
import { AdminClientLayout } from 'pages/atoms';
import { AdminClientAdministrators } from 'containers/admin';

const AdminClientAdministratorsPage: FC = () => {
  return (
    <AdminClientLayout>
      <AdminClientAdministrators />
    </AdminClientLayout>
  );
};

export default AdminClientAdministratorsPage;
